import { z } from "zod";

const boolish = z
  .union([z.literal("true"), z.literal("false"), z.literal("")])
  .default("false")
  .transform((v) => v === "true");

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url().default("http://localhost:5101/v1"),
  VITE_AUTH_REALM: z.string().default("developer"),

  // Social login (OAuth). Sem client_id o provider some/cai no mock.
  // O redirect_uri é derivado do origin: <origin>/auth/callback/<provider>.
  VITE_GOOGLE_CLIENT_ID: z.string().default(""),
  VITE_MICROSOFT_CLIENT_ID: z.string().default(""),
  VITE_MICROSOFT_AUTHORITY: z.string().default("https://login.microsoftonline.com/common"),
  VITE_APPLE_CLIENT_ID: z.string().default(""),

  VITE_MOCK_AUTH: boolish,
  VITE_MOCK_DASHBOARD: boolish,
  VITE_MOCK_LAUNCHES: boolish,
  VITE_MOCK_UNITS: boolish,
  VITE_MOCK_BROKERS: boolish,
  VITE_MOCK_NETWORK: boolish,
  VITE_MOCK_PROPOSALS: boolish,
  VITE_MOCK_MEDIA: boolish,
  VITE_MOCK_USERS: boolish,
  VITE_MOCK_SETTINGS: boolish,
  VITE_MOCK_NOTIFICATIONS: boolish,
  VITE_MOCK_TICKETS: boolish,
  VITE_MOCK_SUBSCRIPTION: boolish,

  VITE_SENTRY_DSN: z.string().default(""),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error("[env] invalid environment:", parsed.error.flatten().fieldErrors);
  throw new Error("Variáveis de ambiente inválidas. Veja o console.");
}

export const env = parsed.data;
export type Env = typeof env;
